module.exports = "/virtual-football-league/img/video/video-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/video-bck.png
// module id = 359
// module chunks = 4